import { adminHttpClient } from "../../../../commons/adminHttpClinet";
import { GetMarketplaceModel, MarketplaceSearch } from "../../../../models/dashboard/marketplace/affiliatesModel";

const getMarketplaces = (model: MarketplaceSearch):Promise<GetMarketplaceModel> => {
    return adminHttpClient.get(`/api/Admin/AdminMarketplace/get-marketplaces?SearchValue=${model.searchValue}&PageNumber=${model.pageNumber}&PageSize=${model.pageSize}&OrderDescending=${model.orderDescending}&SortColumn=${model.sortColumn}&IsDeleted=${model.isDeleted}`)
}

export default getMarketplaces;